<div class="faq-list-item-container">
  @for (item of items; track item.title) {
    @if (authRequired(item)) {
      <button
        class="no-style faq-list-item faq-padding arrow--right faq-list-item-button"
        (click)="openFaqItem(item, 1, item?.generalName)">
        @if ($any(item)?.icon) {
          <div>
            <span class="material-icons-outlined faq-icon">{{ $any(item)?.icon }}</span>
          </div>
        }
        <p class="faq-list-item-text">
          <span
            class="item-title"
            matBadgeOverlap="false"
            [matBadge]="item?.newFlagCount"
            [matBadgeHidden]="item?.newFlagCount === 0">
            {{ item?.title }}
          </span>
        </p>
        <div class="faq-topic-border"></div>
      </button>
    }
  }
</div>
